(function ($, Drupal) {

  'use strict';
  function onDocLittlefootReady(context) {
    const $elements = $(once('initLittlefootBehavior', 'body', context));
    $elements.each(function() {

      // Ensure popovers inside Swiper are not clipped by overflow
      function updateSwiperOverflow() {
        document.querySelectorAll('.swiper').forEach(function (swiper) {
          const hasActivePopover = swiper.querySelector('.littlefoot__popover.is-active');
          if (hasActivePopover) {
            swiper.style.overflow = 'visible';
          } else {
            swiper.style.overflow = '';
          }
        });
      }

      // CON-SR-26-3789426 (2.1.1): link the button to the note it opens, while it is open.
      function buttonFor(popover) {
        return popover && popover.parentElement
          ? popover.parentElement.querySelector('.footnote-button')
          : null;
      }

      function onActivate(popover) {
        if (window.innerWidth <= 768) {
          // document.querySelector('#toTop').classList.add('hard-hide');
        }
        const button = buttonFor(popover);
        if (button && popover.id) {
          button.setAttribute('aria-controls', popover.id);
        }
        // Defer to allow littlefoot to toggle classes
        setTimeout(updateSwiperOverflow, 0);
      }

      function onDismiss(popover) {
        if (window.innerWidth <= 768) {
          // document.querySelector('#toTop').classList.remove('hard-hide');
        }
        const button = buttonFor(popover);
        if (button) {
          button.removeAttribute('aria-controls');
        }
        // Defer to allow littlefoot to toggle classes
        setTimeout(updateSwiperOverflow, 0);
      }

      // initialization of footnotes
      // CON-SR-26-3789426 (2.1.1): "<% reference %>" resolved to a bare "lf-", so every button
      // shared one id. <% number %> is unique per page.
      littlefoot.default({
        buttonTemplate: '<button aria-label="Footnote <% number %>" aria-expanded="false" class="littlefoot-footnote__button footnote-button concorde-footnote" id="lf-btn-<% number %>"></button>',
        activateCallback: onActivate,
        dismissCallback: onDismiss
      });

      // Dynamic numbering
      let footnotes = document.querySelectorAll('.footnote-button ');
      footnotes.forEach((footnote, index) => {
        let number = index + 1;
        footnote.textContent = number;

        // Also number the footnotes list
        let footnoteContent = document.querySelector('#fn' + number + ' .reversefootnote');
        if (footnoteContent) {
          let content = footnoteContent.innerHTML;
          footnoteContent.innerHTML = number + ". " + content;
        }
      });

      // CON-SR-26 (2.4.4 / 2.1.1): drop orphan footnote refs (empty links whose #fn target is missing).
      removeOrphanFootnoteRefs();
    });
  }

  function removeOrphanFootnoteRefs() {
    document.querySelectorAll('a[rel="footnote"]').forEach(function (ref) {
      const href = ref.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      const hasLabel = (ref.textContent || '').trim().length > 0;
      const targetExists = !!document.getElementById(href.slice(1));
      if (targetExists || hasLabel) return; // keep working/labelled footnotes
      const sup = ref.closest('sup.footnote-ref') || ref.parentElement;
      ref.remove();
      // drop the now-empty <sup>
      if (sup && sup.tagName === 'SUP' && !sup.textContent.trim() && !sup.querySelector('a, button')) {
        sup.remove();
      }
    });
  }
  Drupal.behaviors.initLittlefoot = {
    attach: function (context) {
      onDocLittlefootReady();
    }
  };

})(jQuery, Drupal);
